import type { ClientPortfolioToolReportingSummaryResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

type UseToolSummaryResult = {
	totalValue: string;
	totalInvested: string;
	totalCount: number;
	currency: string;
};

export const useToolSummary = (
	toolId: number,
	toolsSummary?: ClientPortfolioToolReportingSummaryResponseDTO[],
): UseToolSummaryResult => {
	const { t } = useResource();

	const toolSummary = toolsSummary?.find((s) => s.toolId === toolId);

	if (!toolSummary) {
		return {
			totalValue: "",
			totalInvested: "",
			totalCount: 0,
			currency: "",
		};
	}

	const currency = t(
		Resources.PortfolioDetail.SharedLabels.Currency[toolSummary.currency],
	);

	return {
		totalValue: moneyFormatter(toolSummary.totalValue, currency, undefined, 0),
		totalInvested: moneyFormatter(
			toolSummary.totalInvestedValue,
			currency,
			undefined,
			0,
		),
		totalCount: toolSummary.totalCount,
		currency,
	};
};
